export const CONFIG = {
  URL: 'https://app.funartmedia.pl',
};
